"use client";
import React from "react";
import { Typography } from "@mui/material";

type FormHeaderProps = {
    title: string;
    isExpanded?:boolean;
  };

const FormHeader: React.FC<FormHeaderProps>= ({ title,
  isExpanded
 }) =>{
  return (
          <Typography 
          className={`pl-4 text-base ${!isExpanded ? "text-TJ-Almost-Black dark:text-TJ-white" : ""}`}
          sx={{
            fontFamily:"Cerebri Sans",
            fontWeight:'600',
            fontSize:'1rem',
            lineHeight:"1.5rem",
            display:"flex",
            alignItems:"center",
            ...(isExpanded && { color: "#FFFFFF" }),
          }}>
            {title}
          </Typography>
  );
}

export default FormHeader;
